import type { IncomingMessage } from 'http';
import { parseCountry } from './country';
import type { SupportedCountry } from './types';
export type TimezoneProviderFn = (req: IncomingMessage) => string;

export const cloudflareRequestTimezoneProvider = (
    fallback: string,
): TimezoneProviderFn => {
    return (req) => {
        let cf = req.headers['cf-timezone'];
        if (Array.isArray(cf)) {
            cf = cf.pop();
        }
        if (cf) {
            return cf;
        }
        const host = req.headers.host;
        if (!host) {
            return fallback;
        }
        return timezoneFromHost(host, fallback);
    };
};

export const timezoneFromHost = (host: string, fallback: string): string => {
    const country = parseCountry.host(host);
    if (!country) {
        return fallback;
    }
    switch (country) {
        case 'AU':
            return 'Australia/Sydney';
        case 'NZ':
            return 'Pacific/Auckland';
        case 'US':
            return 'America/Los_Angeles';
    }
};

export const timezoneFromCountry = (country: SupportedCountry): string => {
    switch (country) {
        case 'AU':
            return 'Australia/Sydney';
        case 'NZ':
            return 'Pacific/Auckland';
        case 'US':
            return 'America/Los_Angeles';
    }
};
